export default __webpack_public_path__ + "static/media/netflix-clone.24cf8153.png";